module.exports = __webpack_public_path__ + "static/media/Kissen_60x30.b3c344a0.png";